import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography'; // Import Typography from MUI
import { Card, Grid, Box, useMediaQuery, Container, Avatar, CardHeader, CardContent, createTheme } from '@mui/material';
import innov from '../../assets/innovatech.png';
import indus from '../../assets/industriesexpert.png';
import cost from '../../assets/costeffective.png';
import value from '../../assets/value.png';
import CheckIcon from '@mui/icons-material/Check';
import image1 from '../../assets/group-people-working-out-business-plan-office.jpg'
import image2 from '../../assets/medium-shot-man-wearing-vr-glasses.jpg';
import servicetop from '../../assets/servicetop.png';
import custsoft from '../../assets/customersoftware.png';
import crm from '../../assets/crm.png';
import bps from '../../assets/bps.png';
import powerapp from '../../assets/powerapp.png';
import softcons from '../../assets/softwareconsult.png';
import softtest from '../../assets/softwaretesting.png';
import webd from '../../assets/webdev.png';
import inno from '../../assets/Innovation.png';
import rpa from '../../assets/rpa.png';
import target from '../../assets/target.png';
import crown from '../../assets/crown.png';
import bulb from '../../assets/bulb.png';
import sol from '../../assets/innovationsolution.png';
import '../home1/index.css'
import approach from '../../assets/approach.png';
import innovator from '../../assets/innovator.png';
import Slider from '../home1/slider.js'
import SliderBenifit from './silderbenifit.js';
import './slider.css'; // Import your CSS file
import image3 from "../../assets/3447021.jpg";
const imageArray = [
    crown, // Add your image URLs here
    target,
    bulb,
];

const Home1 = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setIsVisible(true); // Set visible after component mounts
        }, 100); // Delay before animation starts
    }, [])
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImageIndex((prevIndex) => (prevIndex + 1) % imageArray.length);
        }, 3000); // Change image every 3 seconds

        return () => clearInterval(interval); // Clear interval on unmount
    }, []);
    const Data = [
        "We collaborate with you to understand your unique challenges and aspirations.",
        "Together, we create actionable plans that guide your startup’s journey towards success.",
        "We build tailored solutions that align with your vision and scale with your growth.",
        "Our focus is on delivering reliable and market-ready products.",
        "We ensure your solutions are implemented smoothly within your existing systems.",
        "Our team is here to provide continuous support, keeping your tech running efficiently."
    ]
    const data = [
        {
            "image": custsoft,
            "text": "Custom Software Development"
        },
        {
            "image": softcons,
            "text": "Artificail Intelligence"
        },
        // {
        //     "image": webd,
        //     "text": "BlockChain"
        // },
        // {
        //     "image": softtest,
        //     "text": "Data Analytics"
        // },

        {
            "image": rpa,
            "text": "Robotic Process Automation"
        },
        {
            "image": bps,
            "text": "Business process services"
        },
        {
            "image": powerapp,
            "text": "Security"
        },
        {
            "image": crm,
            "text": "Consultancy"
        },
    ]
    const benifitdata = [
        {
            "image": inno,
            "title": "Innovative Solutions",
            "text": " We leverage advanced technologies to create scalable and sustainable solutions that drive long-term business success."
        },
        {
            "image": approach,
            "title": "Client-Centric Approach",
            "text": "We prioritize our clients, delivering tailored solutions that meet their unique business needs and future goals."
        },
        {
            "image": innovator,
            "title": "Skilled  Innovators",
            "text": "We believe in combining Ideology, Education and Technology to drive innovation  and create impactful solutions."
        },
    ]

    const cards = [
        { id: 1, header: "IT Solutions", content: "Customized technology services that drive innovation, security, and seamless business operations", imageUrl: image1 },
        { id: 2, header: "Operations", content: "Optimize workflows to enhance efficiency, reduce costs, and improve over", imageUrl: image2 },
        { id: 3, header: "Business Growth", content: "Strategic approaches to boost revenue, expand market reach, and achieve sustainable success", imageUrl: image3 },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) =>
                prevIndex === cards.length - 1 ? 0 : prevIndex + 1
            );
        }, 3000); // Change slide every 3 seconds

        return () => clearInterval(interval);
    }, [cards.length]);


    return (
        <>
            <Grid container spacing={4}>
                <Grid item xs={12} sm={8} >
                    <Card
                        style={{
                            backgroundColor: "#0B77A8",
                            borderRadius: "20px",
                            padding: "22px",
                            margin: "20px",
                            borderTopRightRadius: "100px",
                            position: "relative",
                            overflow: "hidden",
                            height: "100%" // Ensures images are clipped within the card
                        }}
                    >
                        <Grid container spacing={4}>
                            <Grid item xs={7} sm={7} md={8} lg={7} xl={5}>
                                <Typography
                                    variant="h3"
                                    sx={{
                                        fontSize: {
                                            xs: "1rem",
                                            sm: "1.8rem",
                                            md: "1.6rem",
                                            lg: "2.5rem",
                                            xl: "2.1rem",
                                        },

                                        lineHeight: {
                                            xs: "1.5rem",
                                            sm: "1.8rem",
                                            md: "unset",
                                            lg: "inherit",
                                            xl: "2",
                                        },
                                        color: "white",
                                    }}
                                    className='poppins-semibold'
                                >
                                    Our dedication to achievement is fueled by our core values......
                                </Typography>
                            </Grid>

                            <Grid item xs={5} sm={5} md={4} lg={5} xl={7}>
                                {/* Image Container */}
                                <Box
                                    sx={{
                                        position: "absolute",

                                        top: 0,
                                        right: 0,
                                        width: "40%", // Adjust based on your layout needs
                                        height: "50%", // Adjust as needed
                                        // borderTopRightRadius: "100px",
                                        overflow: "hidden",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={imageArray[currentImageIndex]}
                                        alt="Sliding Image"
                                        sx={{
                                            width: {
                                                xs: "50%",
                                                sm: "80%",
                                                md: "80%",
                                                xl: "80%",
                                                lg: "80%",

                                            },
                                            height: "100%",
                                            objectFit: "contain",
                                            transition: "transform 0.8s ease-in-out", // Smooth transition effect
                                            transform: "translateY(-100%)", // Start off-screen (above the card)
                                            animation: "slideIn 0.8s ease-in-out forwards", // Apply slide-in animation
                                            // borderTopRightRadius: "100px",
                                        }}
                                    />
                                </Box>
                            </Grid>

                            <Grid item xs={12}>
                                <Box
                                    sx={{
                                        backgroundColor: "white",
                                        height: "2px",
                                        width: "90%",
                                        margin: "10px auto",
                                    }}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant="h6" color="white" className='poppins-regular'>
                                    Innovating IT, Empowering Business.
                                </Typography>
                            </Grid>
                        </Grid>
                    </Card>
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={4}
                    sx={{
                        paddingLeft: {
                            xs: "15px",  // Padding for extra small screens
                            sm: "0px",   // Padding for small screens and up
                            md: "0px",   // Padding for medium screens and up
                            lg: "0px",   // Padding for large screens and up
                            xl: "0px"    // Padding for extra large screens and up
                        },
                        paddingRight: "15px" // Right padding remains constant across all screen sizes
                    }}
                >
                    <Slider />
                </Grid>

            </Grid>
            <Container style={{ textAlign: "center", alignItems: "center", alignContent: "center", paddingTop: "70px", paddingBottom: "70px" }}>
                <Grid container spacing={8}>
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: 'transform 250ms', // Add transition
                            '&:hover': {
                                transform: 'translateY(-10px)' // Lift effect on hover
                            }
                        }}
                    >
                        <Avatar src={cost} sx={{ width: 80, height: 80, }} /> {/* Adjust size as needed */}
                        <Typography variant='h5' sx={{
                            marginTop: 2,
                        }} className='poppins-semibold' >Cost Effective</Typography>
                        <Typography component='p' className='poppins-regular'>
                            We strive to provide top-notch services that maximize value while maintaining affordable pricing, so you receive exceptional quality without overspending.
                        </Typography>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: 'transform 250ms', // Add transition
                            '&:hover': {
                                transform: 'translateY(-10px)' // Lift effect on hover
                            }
                        }}
                    >
                        <Avatar src={indus} sx={{ width: 80, height: 80 }} /> {/* Adjust size as needed */}
                        <Typography variant='h5' sx={{ marginTop: 2 }} className='poppins-semibold'>Domain Expert</Typography>
                        <Typography component='p' className='poppins-regular'>
                            We focus on delivering top-notch services that maximize value and minimize costs, ensuring you achieve outstanding results within your budget.
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sm={4}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            transition: 'transform 250ms', // Add transition
                            '&:hover': {
                                transform: 'translateY(-10px)',// Lift effect on hover
                            }
                        }}
                    >
                        <Avatar src={innov} sx={{ width: 80, height: 80 }} /> {/* Adjust size as needed */}
                        <Typography variant='h5' sx={{ marginTop: 2 }} className='poppins-semibold'>Leading-Edge Tech. Sol.</Typography>
                        <Typography component='p' className='poppins-regular'>
                            Our offerings are crafted to provide exceptional value at affordable prices, guaranteeing you high-quality results without stretching your budget.
                        </Typography>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth={false} style={{ backgroundColor: "rgb(244, 247, 252)", paddingTop: "50px", paddingBottom: "50px" }}>
                <Grid container spacing={5}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box
                            component='img'
                            src={image1}
                            sx={{
                                width: {
                                    xl: "90%",
                                    lg: "70%",
                                    md: "80%",
                                    sm: "100%",
                                    xs: "100%",
                                }
                            }}
                            style={{
                                alignContent: "center",
                                alignItems: "center",
                                width: "70%", // Ensures it takes up the full width of the Grid item
                                height: "auto", // Keeps the aspect ratio intact
                                objectFit: "cover", // Changed to cover for better filling
                                borderRadius: "50%", // Makes the image round
                                overflow: "hidden", // Ensures anything outside the border radius is hidden
                                border: "2px solid #0B77A8" // Optional: Add a border for better visibility
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} style={{ alignContent: "center" }}>
                        <Typography variant='h3' className='poppins-semibold' sx={{
                            fontSize: {
                                xl: "2.0rem",
                                lg: "1.7rem",
                                md: "1.2rem",
                                sm: "1.2rem",
                                xs: "0.9rem"
                            }
                        }}>At <span style={{ color: "#0B77A8" }}>Edgology</span>, we are dedicated to empowering startups with innovative tech support and solutions tailored to your needs:</Typography>
                        {Data.map((item, index) => (
                            <div key={index} style={{ display: "flex", alignItems: "center", marginTop: "10px" }}>
                                <Avatar
                                    style={{
                                        backgroundColor: "white",
                                        marginRight: "5px",
                                        width: "30px", // Reduce width
                                        height: "30px"  // Reduce height
                                    }}
                                >
                                    <CheckIcon
                                        style={{
                                            color: "#0B77A8",
                                            fontSize: "18px" // Reduce icon size
                                        }}
                                    />
                                </Avatar>

                                <Typography component='p' className='poppins-regular' sx={{
                                    fontSize: {
                                        xl: "1.0rem",
                                        lg: "1.0rem",
                                        md: "0.6rem",
                                        sm: "0.7rem",
                                        xs: "0.7rem"
                                    }
                                }}>{item}</Typography>
                            </div>
                        ))}
                    </Grid>
                    <Grid item style={{ textAlign: "left", alignContent: "center", marginTop: "10px" }} xs={6}>
                        <Typography variant='h5' sx={{
                            fontSize: {
                                xl: "1.5rem",
                                lg: "2.0rem",
                                md: "1rem",
                                sm: "1.0rem",
                                xs: "1rem",
                            }, marginBottom: "5px"
                        }} className='poppins-medium'>What We Do</Typography>
                        <Typography
                            variant="h3"
                            sx={{
                                color: "#0B77A8",
                                fontSize: {
                                    xl: "2.0rem",
                                    lg: "1.7rem",
                                    md: "1.2rem",
                                    sm: "1.2rem",
                                    xs: "0.9rem"
                                },
                                marginBottom: "10px",
                            }}
                            className="poppins-semibold"
                        >
                            Empowering Your Business with Innovative Solutions
                        </Typography>

                        <Typography component='p' className='poppins-regular' sx={{
                            fontSize: {
                                xl: "1.0rem",
                                lg: "1.0rem",
                                md: "0.6rem",
                                sm: "0.7rem",
                                xs: "0.7rem"
                            }
                        }}>Our team delivers customized technology solutions crafted to improve efficiency, drive growth, and foster innovation within your organization.
                            Whether it's through automation, AI integration, or CRM modernization,
                            we provide forward-thinking approaches that optimize processes, boost productivity, and prepare your business for sustained success in the ever-evolving digital landscape.</Typography>
                    </Grid>
                    <Grid item xs={6} justifyContent="center" alignItems="center" >
                        <Box
                            component='img'
                            src={image2}
                            sx={{
                                width: {
                                    xl: "80%",
                                    lg: "80%",
                                    md: "90%",
                                    sm: "100%",
                                    xs: "100%",
                                },
                                height: {
                                    xl: "auto",
                                    lg: "auto",
                                    md: "auto",
                                    sm: "auto",
                                    xs: "50%",
                                }, // Keeps the aspect ratio intact
                                objectFit: "cover", // Ensures the image fills the container while maintaining aspect ratio
                                borderRadius: "15px", // Rounds the image
                                overflow: "hidden", // Ensures anything outside the border radius is hidden
                                border: "2px solid #0B77A8", marginTop: "10px"
                            }}
                            
                        />
                    </Grid>
                </Grid>
            </Container>
            <Container style={{ paddingTop: "50px", paddingBottom: "50px" }} >
                <Grid container spacing={5}>
                    {/* Heading section */}
                    <Grid
                        item
                        xs={12}

                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            paddingTop: "70px"
                        }}
                    >
                        <Typography variant='h4' style={{ color: "black", marginRight: "5px" }} className='poppins-semibold'>
                            OUR
                        </Typography>
                        <Typography variant='h4' style={{ color: "#1166A6" }} className='poppins-semibold'>
                            BENEFITS
                        </Typography>
                    </Grid>

                    {/* Paragraph section */}
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography
                            component='p'
                            className='poppins-regular'
                            sx={{
                                fontSize: {
                                    xl: "1.5rem",
                                    lg: "1.5rem",
                                    xs: "0.7rem",
                                    sm: "1.2rem",
                                    md: "1rem"
                                },
                                color: "black",
                                flex: 1,
                                textAlign: 'center',
                                margin: '0',
                                padding:"5px",
                                marginLeft: {
                                    xl: "30px",
                                    lg: "30px",
                                    xs: "0px",
                                    sm: "30px",
                                    md: "30px"
                                }
                            }}
                        >
                            We strive to transform businesses through state-of-the-art IT solutions that are seamlessly integrated,
                            improve operational efficiency, and deliver transformative outcomes.
                            Our focus is on empowering clients to excel in a rapidly evolving digital landscape.
                        </Typography>
                    </Grid>
                </Grid>

            </Container>
            <Container maxWidth={false} sx={{ padding: "50px 20px" }}>
                <Grid container spacing={4}>
                    {/* Slider Box */}
                    <Grid item xs={12} sm={3} sx={{ padding: "0px 0px 0px 20px", maxWidth: { xs: '100%', sm: '25%' } }}>
                        <SliderBenifit />
                    </Grid>

                    {/* Benefit Cards */}
                    {benifitdata.map((item, index) => (
                        <Grid item xs={12} sm={3} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Card
                                sx={{
                                    color: "black",
                                    borderTopRightRadius: "60px",
                                    border: "2px solid #0B77A8",
                                    width: "100%", // Let card take full width of the grid item
                                    maxWidth: "300px", // Set a max width if necessary
                                    height: "300px",
                                    transition: "background-color 0.3s ease",
                                    backgroundColor: "#ffffff",
                                }}
                            >
                                <CardHeader style={{ display: "grid" }}
                                    avatar={
                                        <Box component='img' src={item.image} style={{ width: '50px', height: '50px', marginBottom: "10px" }} />
                                    }
                                    title={<Typography variant="h6" className='poppins-semibold'>{item.title.split(' ')[0]} <br /> {item.title.split(' ').slice(1).join(' ')}</Typography>}
                                />
                                <CardContent>
                                    <Typography variant="body2" className='poppins-regular'>
                                        {item.text}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <h2 className="fancy" style={{ '--w': '50vw', '--c': ' #1166A6', '--b': '4px', '--g': "-5px" }} >
                <Typography
                    variant="h4" className='poppins-semibold'
                    style={{
                        textAlign: 'center', // Center align the text
                        color: 'black', // Set text color to black

                    }}
                >
                    OUR
                    <span style={{ color: 'white' }} className='poppins-semibold'> SOLUTIONS </span>

                </Typography>
            </h2>
            <Container style={{ padding: '0', position: 'relative', textAlign: 'center', paddingRight: "20px", paddingLeft: "20px", paddingTop: "40px" }}>
                <Grid container spacing={5}>
                    {data.map((item, index) => (
                        <Grid item xs={12} sm={12} md={4} lg={4} key={index}>
                            <Card
                                sx={{
                                    borderRadius: "8px",
                                    display: "flex", // Use flexbox for alignment
                                    flexDirection: "column", // Align content vertically
                                    justifyContent: "space-between", // Distribute space evenly
                                    height: "250px", // Set a fixed height
                                    textAlign: "center", // Center text in card
                                    padding: '15px',
                                    backgroundColor: "#e2f3ff",
                                    transition: 'transform 250ms', // Add transition
                                    '&:hover': {
                                        transform: 'translateY(-10px)' // Lift effect on hover
                                    }
                                }}
                            >
                                <img
                                    src={item.image}
                                    alt="image"
                                    style={{
                                        width: '100%',
                                        maxHeight: '120px', // Set max height for the image
                                        objectFit: 'contain', // Maintain aspect ratio
                                        marginBottom: '0px'
                                    }}
                                />
                                <Typography
                                    variant="h6"
                                    className='poppins-regular'
                                    style={{ color: "black", marginTop: '10px' }}
                                >
                                    {item.text}
                                </Typography>

                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
            <Container >
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingTop: "70px" }}>
                    <Typography variant='h4' style={{ color: "black", marginRight: "5px" }} className='poppins-semibold'>
                        MEET
                    </Typography>
                    <Typography variant='h4' style={{ color: "#1166A6" }} className='poppins-semibold'>
                        EDGOLOGY
                    </Typography>
                </div>
                <div style={{ textAlign: 'center', margin: '20px 00px' }}>
                    <Typography component='p' className='poppins-regular'>
                        At <span style={{ color: "#1166A6" }}>Edgology</span>, we believe in the perfect blend of Ideology, Education, and Technology to fuel innovation and growth. We are a forward-thinking IT and software solutions provider, dedicated to helping businesses unlock their full potential through cutting-edge technology. Our expert team specializes in delivering tailored solutions in consulting, development, automation, BPS, and AI to empower companies with the tools they need to thrive in today's fast-paced digital world.
                    </Typography>
                </div>
                <div style={{ textAlign: 'center', margin: '20px 0' }}>
                    <Typography component='p' className='poppins-regular' >
                        With a passion for progress and a focus on quality, we work closely with our clients to understand their unique challenges and offer customized strategies to drive success. Whether you're looking to modernize legacy systems, streamline operations, or innovate with Al, Edgology is here to support your vision and turn it into reality. </Typography>
                </div>
                <div style={{ textAlign: 'center', margin: '20px 0', paddingBottom: "70px" }}>
                    <Typography component='p' className='poppins-regular' style={{ color: "#1166A6" }}>
                        Where ideas, education, and technology meet for transformative business growth.

                    </Typography></div>
            </Container>
            <style jsx global>{`
        @keyframes slideIn {
          0% {
            transform: translateY(-100%); /* Start off-screen above the view */
          }
          100% {
            transform: translateY(0); /* End at the original position */
          }
        }
      `}</style>
        </>
    );
};

export default Home1;
